export const wixStudioToolBarDataHooks = {
  editorLink: 'editor-link',
  deviceToggle: 'device-toggle',
};
